module.exports = __webpack_public_path__ + "images/TacoBouncer.656dc3a1db8d11cde974.png";